var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.286 12c-.53-.007-1.033-.14-1.526-.324-.81-.302-1.55-.733-2.256-1.226a16.064 16.064 0 0 1-2.25-1.918c-.883-.9-1.67-1.875-2.298-2.972C.52 4.793.168 3.993.034 3.113A2.41 2.41 0 0 1 .113 1.97c.072-.215.19-.401.349-.561.35-.35.7-.701 1.052-1.05A1.207 1.207 0 0 1 3.229.356c.544.538 1.086 1.077 1.623 1.621.45.455.474 1.102.068 1.575a1.116 1.116 0 0 1-.465.304c-.405.156-.666.437-.753.868a.912.912 0 0 0 .027.415c.132.517.4.963.729 1.374.513.641 1.118 1.174 1.857 1.543.267.134.543.241.853.21.416-.042.726-.24.916-.616.024-.049.044-.1.064-.15.297-.745 1.236-.965 1.816-.41A66.942 66.942 0 0 1 11.68 8.8c.445.458.42 1.194-.043 1.668-.357.366-.72.726-1.085 1.084-.35.344-.788.454-1.266.45V12Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h12v12H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default ForwardRef;